import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { login, loginByGoogle, loginByYahoo } from "../../redux/slices/auth";
import { useLocation, useNavigate, Link } from "react-router-dom";
import LOGO from "../../assets/images/auth/logo-sevenly.png";
import { TextField, IconButton, InputAdornment } from "@mui/material";
import { GoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import Modal from "../../components/Modal";
import TextBox from "../../components/textbox";
import axios from "axios";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import PasswordInput from "../../components/passwordbox";
import Spinner from "../../components/Spinner";
import YahooButton from "../../assets/images/auth/yahoologin.png";
const Login = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [email, setEmail] = useState();
  const [loader, setLoader] = useState(false);
  const [otp, setOtp] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [fpassword, setFPassword] = useState();
  const [password, setPassword] = useState();
  const [open, setOpen] = useState();
  const [forgetEmail, setForgetEmail] = useState();
  const [showPassword, setShowPassword] = useState(false);
  const [tabValue, setTabValue] = useState(1);
  const { name, token, useremail, error, loading, picture } = useSelector(
    (state) => state.auth
  );
  const redirectUriLogin = window.location.origin + window.location.pathname;

  // On component mount, fetch user data if a token exists
  useEffect(() => {
    if (token) {
      // dispatch(fetchUser());
      toast.success("Welcome to Sevenly travel!");
      navigate("/");
    }
    if (error) {
      toast.error(error);
    }
  }, [token, dispatch, error]);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const code = queryParams.get("code");
    const state = queryParams.get("state");

    if (code) {
      // We have a code from Yahoo; now exchange it for tokens
      exchangeCodeForTokens(code);
    } else {
      localStorage.removeItem("yahoo_oauth_state");
      localStorage.removeItem("yahoo_code_verifier");
    }
  }, [location]);

  const handleLogin = async () => {
    const credentials = { email: email, password: password };
    dispatch(login(credentials));
  };
  const handleClose = () => {
    setOpen(false);
    setTabValue(1);
    setForgetEmail("");
    setOtp("");
  };

  const sendOtp = () => {
    setLoader(true);
    axios
      .post(process.env.REACT_APP_BACKEND + "auth/forgotpasswordgenerate", {
        email: forgetEmail,
      })
      .then((resp) => {
        setTabValue(2);
        toast.success(resp.data.message);
        setLoader(false);
      })
      .catch((err) => {
        console.log(err);
        setLoader(false);
        toast.error(err.response.data.message);
      });
  };
  const changePassword = () => {
    axios
      .post(process.env.REACT_APP_BACKEND + "auth/forgotpasswordverify", {
        otp: otp,
        newPassword: fpassword,
        confirmPassword: confirmPassword,
        email: forgetEmail,
      })
      .then((resp) => {
        setTabValue(2);
        handleClose();
        toast.success(resp.data.message);
        setForgetEmail("");
        setFPassword("");
        setConfirmPassword("");
        setOtp("");
      })
      .catch((err) => {
        console.log(err);
        toast.error(err.response.data.message);
      });
  };
  const forgetPasswordBody = () => {
    return (
      <div className="mt-3">
        {tabValue === 1 && (
          <div>
            <TextBox
              label="Email"
              placeholder="Enter your Email"
              value={forgetEmail}
              onChange={(e) => setForgetEmail(e.target.value)}
              size="medium"
            />
            <div className="t-center mt-3  d-flex  justify-content-center   ">
              <button
                className="btn-contained d-flex align-items-center justify-content-center  "
                onClick={sendOtp}
              >
                <p className="me-2"> Send OTP </p>
                {loader && <Spinner />}
              </button>
            </div>
          </div>
        )}

        {tabValue === 2 && (
          <div>
            <TextBox
              label="Otp"
              placeholder="Enter 6 digit Otp"
              value={otp}
              onChange={(e) => setOtp(e.target.value)}
              size="medium"
              maincontStyle={{ marginTop: "10px" }}
            />

            <p className="textbox-label fw-500 mt-2"> Enter new Password</p>
            <PasswordInput
              placeholder="Enter new Password"
              value={fpassword}
              onPasswordChange={(value) => setFPassword(value)}
            />

            <p className="textbox-label fw-500 mt-2"> Enter confirm Password</p>
            <PasswordInput
              placeholder="Enter confirm Password"
              value={confirmPassword}
              onPasswordChange={(value) => setConfirmPassword(value)}
            />
            <div
              className="d-flex justify-content-end mt-4"
              style={{ gap: 20 }}
            >
              <button className="btn-contained" onClick={handleClose}>
                {" "}
                Cancel
              </button>
              <button className="btn-contained" onClick={changePassword}>
                {" "}
                Submit
              </button>
            </div>
          </div>
        )}
      </div>
    );
  };

  const handleLoginSuccess = (credentialResponse) => {
    const data = { tokenId: credentialResponse?.credential };
    dispatch(loginByGoogle(data));
  };

  const handleLoginFailure = () => {
    console.log("Login Failed");
  };
  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };

  const generateRandomString = (length) => {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
    let result = "";
    for (let i = 0; i < length; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };

  // Utility to compute code_challenge from code_verifier
  const generateCodeChallenge = async (codeVerifier) => {
    const encoder = new TextEncoder();
    const data = encoder.encode(codeVerifier);
    const digest = await crypto.subtle.digest("SHA-256", data);
    return btoa(String.fromCharCode(...new Uint8Array(digest)))
      .replace(/\+/g, "-")
      .replace(/\//g, "_")
      .replace(/=+$/, "");
  };

  const handleYahooLogin = async () => {
    const clientId = process.env.REACT_APP_YAHOO_CLIENT_ID;
    const scope = "openid email profile";
    const state = Math.random().toString(36).substring(2); // CSRF protection
    const codeVerifier = generateRandomString(43); // 43-128 chars
    const codeChallenge = await generateCodeChallenge(codeVerifier);

    const authUrl = `https://api.login.yahoo.com/oauth2/request_auth?client_id=${clientId}&redirect_uri=${encodeURIComponent(
      redirectUriLogin
    )}&response_type=code&scope=${encodeURIComponent(
      scope
    )}&state=${state}&code_challenge=${encodeURIComponent(
      codeChallenge
    )}&code_challenge_method=S256`;

    // Store state and code_verifier
    localStorage.setItem("yahoo_oauth_state", state);
    localStorage.setItem("yahoo_code_verifier", codeVerifier);

    window.location.href = authUrl;
  };

  const exchangeCodeForTokens = async (code) => {
    try {
      // Retrieve the code_verifier from sessionStorage
      const codeVerifier = localStorage.getItem("yahoo_code_verifier");
      if (!codeVerifier) {
        throw new Error("Error.");
      }

      const bodyParams = {
        code: code,
        code_verifier: codeVerifier,
        redirect_uri: redirectUriLogin,
      };
      dispatch(loginByYahoo(bodyParams));
    } catch (err) {
      toast.error("Please refresh and retry.");
      console.error("Error exchanging code for tokens", err);
    }
  };

  return (
    <div className="logincont">
      <div
        className="bx-shadow-large w30 d-flex align-items-center justify-content-center flex-column "
        style={{
          backgroundColor: "var(--black-color)",
          borderRadius: "8px",
          color: "var(--white-color)",
          padding: "20px 50px",
        }}
      >
        <img
          className="my-4 c-pointer w20"
          style={{ height: "auto" }}
          onClick={() => navigate("/")}
          src={LOGO}
        />
        <h1 className="mb-4">
          Welcome to{" "}
          <span style={{ color: "var(--primary-color)" }}>Sevenly Travel </span>
        </h1>
        <div className="mt-2 px-4">
          <TextField
            id="outlined-basic"
            label="Email"
            variant="outlined"
            fullWidth
            onChange={(e) => setEmail(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "white",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white",
                },
                borderRadius: "50px",
                color: "white",
                fontFamily: "'Poppins', sans-serif",
              },
              "& .MuiInputLabel-root": {
                color: "white",
                fontFamily: "'Poppins', sans-serif",
                "&.Mui-focused": {
                  color: "white",
                },
              },
              input: {
                color: "white",
                fontFamily: "'YourFontFamily', sans-serif",
              },
            }}
          />

          <TextField
            id="outlined-basic"
            label="Password"
            variant="outlined"
            className="mt-3"
            type={showPassword ? "text" : "password"}
            fullWidth
            onChange={(e) => setPassword(e.target.value)}
            sx={{
              "& .MuiOutlinedInput-root": {
                "& fieldset": {
                  borderColor: "white",
                },
                "&:hover fieldset": {
                  borderColor: "white",
                },
                "&.Mui-focused fieldset": {
                  borderColor: "white",
                },
                borderRadius: "50px",
                color: "white",
              },
              "& .MuiInputLabel-root": {
                color: "white",
                fontFamily: "'Poppins', sans-serif",
                "&.Mui-focused": {
                  color: "white",
                },
              },
              input: {
                color: "white",
                fontFamily: "'Poppins', sans-serif",
              },
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <IconButton
                    onClick={togglePasswordVisibility}
                    edge="end"
                    style={{ color: "#FFF" }}
                  >
                    {showPassword ? (
                      <VisibilityOff style={{ color: "#FFF" }} />
                    ) : (
                      <Visibility style={{ color: "#FFF" }} />
                    )}
                  </IconButton>
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div>
          <p
            className="fs-8 mt-2 c-pointer"
            style={{ color: "var(--primary-color)" }}
            onClick={() => setOpen(true)}
          >
            Forgot Password?
          </p>
        </div>
        <button
          className="btn-contained my-4 w30"
          style={{ borderRadius: "50px" }}
          onClick={handleLogin}
        >
          Login
        </button>
        <p className="mb-3">
          Don’t have account{" "}
          <Link to="/signup" style={{ color: "var(--primary-color)" }}>
            ? Sign up.
          </Link>
        </p>
        <div className="mb-3">
          <GoogleLogin
            onSuccess={handleLoginSuccess}
            onError={handleLoginFailure}
            className="custom-google-login-button"
            shape="circle"
            size="large"
            width="200px"
          />
        </div>
        <div className="mb-3">
          <img
            src={YahooButton}
            alt="Sign in with Yahoo"
            onClick={handleYahooLogin}
            style={{
              width: "200px",
              height: "40px",
              cursor: "pointer",
              borderRadius: "8px",
              boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
            }}
          />
        </div>
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        title="Forgot Password"
        children={forgetPasswordBody()}
        // actions={actions}
        size="sm"
      />
    </div>
  );
};

export default Login;
